export default __webpack_public_path__ + "static/media/inventory-kits-gray.c3ccf6eb.svg";